import { type ServiceMethod } from '@/application/interfaces/service';
import { type ItemId } from '@/infra/services/catalog/model';

import { type Service } from './model';

export type Params = {
  itemId: ItemId;
};

export type Response = {
  data: {
    product: Service;
  };
};

const getServiceInfo: ServiceMethod<Response, Params> =
  (httpClient) => async (data, options) => {
    const { itemId } = data;

    const { body: response } = await httpClient.get<Response, Params>(
      '/api/v3/services/{itemId}',
      {
        ...options,
        params: {
          itemId,
        },
      }
    );

    return response;
  };

export default getServiceInfo;
